import React, { useState, useContext, useEffect } from 'react'
import Connexion from '../../../components.js/serveur/authentification/Connexion'
import useForm from '../../../hooks/useForm'
import { AppContext } from '../../../App'
import Deconnexion from '../../../components.js/serveur/authentification/Deconnexion'
import useAuthFirebase from './../../../firebase/useAuthFirebase';

const AUTH_STATE = {
    email:'',
    password:'',
}

const Auth = () => {
    const { user } = useContext(AppContext)
    const { _signIn, _signOut, _forgotPassword } = useAuthFirebase()
    const { handleChange, values } = useForm(AUTH_STATE)

    return (
        <div className='container-fluid'>
            {user.uid ? 
                <Deconnexion
                    _signOut={_signOut}
                />
            : 
                <Connexion 
                    _signIn={_signIn}
                    _forgotPassword={_forgotPassword}
                    handleChange={handleChange}
                    values={values}
                />
            }
        </div>
    )
}

export default Auth